var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101820;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 60",
    id: "Layer_60"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,18a2,2,0,1,1,2-2A2,2,0,0,1,16,18Zm0-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,7a2,2,0,1,1,2-2A2,2,0,0,1,16,7Zm0-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 16,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,29a2,2,0,1,1,2-2A2,2,0,0,1,16,29Zm0-2Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsIcon);
export default __webpack_public_path__ + "static/media/dots_icon.7c8282fa2a0267fe274dc101ea410ab4.svg";
export { ForwardRef as ReactComponent };